import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function auth0Login(accessToken) {
  const axios = axiosInstance().primoLab;
  let data = [];

  await axios
    .post("/auth/auth0-login", { access_token: accessToken })
    .then(async (response) => {
      data = response.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { data };
}
